<div *transloco="let t">
  <div class="mt-4 mb-3">
    <nav class="flex column-gap-1">
      <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last; let first = first">
        <ng-container *ngIf="!last">
          <a [routerLink]="breadcrumb.url">{{ t('breadcrumb.' + breadcrumb.label) | titlecase }}</a>
          <i class="pi pi-angle-right" style="font-size: 1.2rem"></i>
        </ng-container>
        <ng-container *ngIf="last">
          {{ t('breadcrumb.' + breadcrumb.label) | titlecase }}
        </ng-container>
      </ng-container>
    </nav>
  </div>
</div>
